var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"width":"20px","height":"20px","src":require("@/assets/icon/spam.svg"),"alt":"filterIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }